import React from 'react';
import StyleItModal from './StyleItModal';

const FirstRunFlow = () => {
	return <StyleItModal />;
};

export { FirstRunFlow };
